



















import {
  DynamicDocumentItem,
  InstallationModuleData,
  ListItem,
  MechanicInstallation,
  PanelLocation,
} from '@/types';

import Vue, { PropType } from 'vue';

export default Vue.extend({
  props: {
    item: Object as PropType<DynamicDocumentItem>,
    moduleData: Object as PropType<InstallationModuleData>,
    installation: { type: Object as PropType<MechanicInstallation> },
  },

  computed: {
    panelLocations(): ListItem<PanelLocation>[] {
      return [
        { text: 'Voor', value: 'voor' },
        { text: 'Achter', value: 'achter' },
        { text: 'Zijkant', value: 'zijkant' },
        { text: 'Plat', value: 'plat' },
      ];
    },
  },

  mounted() {
    if (!this.moduleData.locationPanels) {
      this.moduleData.locationPanels = this.installation.screening.panelsLocation;
      this.$emit('save:module');
    }
  },
});
